/*
 * @FilePath     : /es-package/packages/es-mpx-router/lib/index.js
 * @Author       : LiYang
 * @Date         : 2022-01-10 17:27:09
 * @LastEditTime : 2022-03-10 11:12:36
 * @LastEditors  : Please set LastEditors
 * @Description  : 
 */

import Router from './Router'

export default app => {
  const router = new Router(app);
  // 全局router
  app.use(function (Ctor, option, mpx) {
    mpx.$mpxRouter = router;
    Object.defineProperty(Ctor.prototype, '$mpxRouter', {
      enumerable: true,
      configurable: true,
      get () {
        return router
      }
    })
  })

  // 页面内部route包含url和参数
  app.injectMixins({
    created() {
      router.enter(this)
    },
    computed: {
      $mpxRoute() {
        const ctx = this;
        return (
          this.$route 
          ? this.$route 
          : Object.defineProperties({}, {
              path: {
                get() {
                  return ctx.route
                }
              },
              query: {
                get() {
                  return ctx.options
                }
              }
          })
        )
      }
    }
  }, ['page', 'component']) 
}
